var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "studio-page-header",
        class: { "studio-page-header-long": !_vm.is_sidebar_minimized },
        staticStyle: {
          "padding-bottom": "0 !important",
          "padding-top": "15px !important",
          height: "110px"
        }
      },
      [
        _c("div", { staticClass: "title-tab-experience-manager" }, [
          _vm._v("ADMINISTRATOR")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex m__t--45" },
          [
            _vm._l(_vm.tabMenu, function(tab, index) {
              return [
                tab.show
                  ? _c(
                      "div",
                      {
                        key: tab.label,
                        class: [
                          { "m__r--35": index < _vm.tabMenu.length - 1 },
                          tab.active
                            ? "tab-experience-manager-active"
                            : "tab-experience-manager"
                        ],
                        on: {
                          click: function($event) {
                            _vm.$router.replace(tab.url)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(tab.label) + "\n        "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            })
          ],
          2
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "studio-page-administrator-content" },
      [
        _c(
          "b-form-group",
          {
            staticClass: "company-profile-page card-body application-row",
            staticStyle: { "background-color": "#ffffff" }
          },
          [
            _c(
              "div",
              { staticClass: "profile-page__body" },
              [
                _c(
                  "b-container",
                  { attrs: { fluid: "" } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "4" } },
                          [
                            _c("j-singleupload", {
                              attrs: {
                                "accepted-file-type": ["jpg", "png", "jpeg"],
                                "api-token": _vm.tokenApi,
                                "img-default": _vm.company_profile.image_url,
                                "url-upload": _vm.url_upload
                              },
                              on: { url: _vm.getNewProfileImage }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { cols: "8" } },
                          [
                            _c(
                              "b-form-group",
                              { staticClass: "profile-page__section" },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    class: { "error-input": _vm.$v.name.$error }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "bold",
                                        attrs: { for: "name" }
                                      },
                                      [_vm._v("Name")]
                                    ),
                                    _vm._v(" "),
                                    _c("j-input", {
                                      attrs: { id: "name", type: "text" },
                                      model: {
                                        value: _vm.company_profile.name,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.company_profile,
                                            "name",
                                            $$v
                                          )
                                        },
                                        expression: "company_profile.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    class: {
                                      "error-input": _vm.$v.phone.$error
                                    }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "bold",
                                        attrs: { for: "phone" }
                                      },
                                      [_vm._v("Phone Number")]
                                    ),
                                    _vm._v(" "),
                                    _c("j-input", {
                                      attrs: { id: "phone", type: "text" },
                                      model: {
                                        value: _vm.company_profile.phone,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.company_profile,
                                            "phone",
                                            $$v
                                          )
                                        },
                                        expression: "company_profile.phone"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    class: {
                                      "error-input": _vm.$v.phone_finance.$error
                                    }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "bold",
                                        attrs: { for: "phone_finance" }
                                      },
                                      [_vm._v("Phone Finance")]
                                    ),
                                    _vm._v(" "),
                                    _c("j-input", {
                                      attrs: {
                                        id: "phone_finance",
                                        type: "text"
                                      },
                                      model: {
                                        value:
                                          _vm.company_profile.phone_finance,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.company_profile,
                                            "phone_finance",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "company_profile.phone_finance"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    class: {
                                      "error-input": _vm.$v.web_url.$error
                                    }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "bold",
                                        attrs: { for: "web_url" }
                                      },
                                      [_vm._v("Web Url")]
                                    ),
                                    _vm._v(" "),
                                    _c("j-input", {
                                      attrs: { id: "web_url", type: "text" },
                                      model: {
                                        value: _vm.company_profile.web_url,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.company_profile,
                                            "web_url",
                                            $$v
                                          )
                                        },
                                        expression: "company_profile.web_url"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    class: {
                                      "error-input": _vm.$v.address.$error
                                    }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "bold",
                                        attrs: { for: "address" }
                                      },
                                      [_vm._v("Address")]
                                    ),
                                    _vm._v(" "),
                                    _c("j-input", {
                                      attrs: { id: "address", type: "text" },
                                      model: {
                                        value: _vm.company_profile.address,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.company_profile,
                                            "address",
                                            $$v
                                          )
                                        },
                                        expression: "company_profile.address"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    class: {
                                      "error-input": _vm.$v.description.$error
                                    }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "bold",
                                        attrs: { for: "description" }
                                      },
                                      [_vm._v("Description")]
                                    ),
                                    _vm._v(" "),
                                    _c("j-textarea", {
                                      attrs: { id: "description", rows: 3 },
                                      model: {
                                        value: _vm.company_profile.description,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.company_profile,
                                            "description",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "company_profile.description"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "btn btn-import-form pull-right",
                                on: { click: _vm.updateCompanyProfile }
                              },
                              [
                                _c("i", { staticClass: "fa fa-cloud-upload" }),
                                _vm._v(
                                  "\n                Update\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("j-problem-screen", {
          ref: "problemScreen",
          attrs: { message: _vm.error_prompt }
        }),
        _vm._v(" "),
        _c("j-loading-screen", { ref: "loadingScreen" }),
        _vm._v(" "),
        _c("j-success-screen", {
          ref: "successScreen",
          attrs: { message: _vm.success_prompt }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53b94e8c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53b94e8c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/company/jCompanyProfile.vue
// module id = null
// module chunks = 